<template>
    <div class="section" id="sobre" ref="sobre">
        <div class="wrap" v-prlx="{
                reverse: true,
                speed: 0.2,
                preserveInitialPosition: false,
                //limit: { min: 0 },
                fromBottom: false
            }">

            <b-container class="fluid">
                <b-row class="px-4">
                    <b-col class="col-md-12 col-lg-5">
                        <div class="caption">
                            <h2 class="h3 tit-mini-dest tit-mini-dest--dark"><strong>{{ texto_sobre.title }}</strong></h2>
                            <p v-html="texto_sobre.description"/>
                        </div>
                    </b-col>
                    <b-col class="col-md-1 col-lg-1"></b-col>
                    <b-col class="col-md-12 col-lg-6 d-flex justify-content-center">
                        <a href="https://encfy.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Conheça a Encfy (abre em nova aba)" class="link-encfy">
                            <picture class="img-zoom">
                                <img :src="texto_sobre.link" alt="Conheça a Encfy — a nova plataforma da ENC que impulsiona suas promoções com menor custo. Clique aqui.">
                            </picture>
                        </a>
                    </b-col>
                </b-row>
            </b-container>

        </div>
    </div>

</template>

<script>

export default {
    name: "App",
    props: {
        texto_sobre: {}
    },

}
</script>

<style scoped lang="scss">
@import "../assets/scss/global";
    .link-encfy {
        border-radius: 4px;
        &:focus-visible {
            outline: 3px solid $cor1;
            outline-offset: 4px;
        }
    }
    @media (max-width: $mobile){
        .row{
            flex-flow: column;
            text-align: center;
        }
    }

</style>
